import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../../constants/colors";

export default makeStyles((theme) => ({
  colorPrimary: {
    color: "#F8DA76",
  },
  backgroundColorPrimary: {
    background: "#F8DA76",
  },
  bannerItem: {
    width: "100%",
    height: "375px",
  },
  bannerTitle: {
    color: `${COLORS.accent}`,
    fontFamily: "Montserrat",
  },
  bannerSubtitle: {
    color: `${COLORS.accent}`,
    fontFamily: "Blinker",
    fontSize: 22
  },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  mainOverlay: {
    position: "absolute",
    width: "100%",
    height: "inherit",
    top: 0,
    left: 0,
  },
  backgroundOverlay: {
    backgroundColor: "black",
    opacity: "0.6",
  },
  bannerOverlay: {
    zIndex: 1000,
    flexDirection: "column",
  },
  iconContainer: {
    width: "85px",
    height: "85px",
    borderRadius: "50%",
    border: `2px solid ${COLORS.accent}`,
    background: "transparent",
  },
  divider: {
    width: "300px",
    height: "3px",
  },
  button: {
    backgroundColor: `${COLORS.accent}`,
    "&:hover": {
      backgroundColor: `${COLORS.accentDark}`,
      "@media (hover: none)": {
        backgroundColor: `${COLORS.accent}`,
      },
    },
    textDecoration: "none",
    padding: "5px 50px",
    marginTop: "20px",
  },
  bannerContent: {
    textAlign: "center",
    flexDirection: "column",
    padding: "10px",
  },
  bannerImage: {
    width: "100%",
    height: "inherit",
    objectFit: "cover",
  },
}));
